module.exports = __webpack_public_path__ + "static/media/high_five_click_here@3x.aa085f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/high_five_click_here@3x.png
// module id = 470
// module chunks = 0